import clsx from "clsx";
import { IconProps } from "@/types/icons.ts";
import { createColorClasses } from "@/theme/colors";

export const Download = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "Download",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill={clsx(color ? color : "#06C")}
        fillRule="evenodd"
        d="m7.7 9.9 4.3 4.3 4.3-4.3-.7-.7-3.1 3V3h-1v9.3L8.4 9.2zM19 19.5V12h1v7.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19.5V12h1v7.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

